
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';

// Function to play notification sounds
export const playNotificationSound = async (soundType: 'notification' | 'error' | '404' = 'notification') => {
  try {
    // Determine which sound file to play
    let soundFileName = 'notification.mp3';
    
    switch (soundType) {
      case 'error':
        soundFileName = 'error.mp3';
        break;
      case '404':
        soundFileName = 'notification.mp3'; // Using the same sound for now
        break;
      default:
        soundFileName = 'notification.mp3';
    }
    
    const audio = new Audio();
    
    // Handle differently based on platform
    if (Capacitor.isNativePlatform()) {
      try {
        // Try to read from the app's assets directory first
        const result = await Filesystem.readFile({
          path: `assets/sounds/${soundFileName}`,
          directory: Directory.Data
        });
        
        // Convert and play
        const base64Sound = `data:audio/mp3;base64,${result.data}`;
        audio.src = base64Sound;
      } catch (error) {
        // Fallback to public URL if file doesn't exist in app directory
        console.log('Falling back to public sound file');
        audio.src = `/assets/sounds/${soundFileName}`;
      }
    } else {
      // Web browser - use the public URL
      audio.src = `/assets/sounds/${soundFileName}`;
    }
    
    await audio.play();
  } catch (error) {
    console.error('Failed to play notification sound:', error);
  }
};

// Function to check and fix paths for 404 errors
export const checkRouteValidity = (path: string): boolean => {
  // List of valid base routes - could be generated from your router config
  const validRoutes = [
    '/', '/dashboard', '/students', '/teachers', '/timetable', 
    '/reports', '/settings', '/search', '/about-us', '/help-center',
    '/certificate-templates', '/total-students', '/revenue', '/programs'
  ];
  
  // Check if path starts with any valid route
  return validRoutes.some(route => 
    path === route || path.startsWith(`${route}/`)
  );
};
